import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { channelOrderItemOfOrderFromAmazon, checkPostalCode, convertName, editOrder, restoreOrderAmazon, updateOrder } from '../utils/orders';
import { EDIT_ORDER, EDIT_ORDER_FAILS, EDIT_ORDER_SUCCESS, RESTORE_ORDER, UPDATE_ORDER, UPDATE_ORDER_FAILS, UPDATE_ORDER_SUCCESS } from './../actions/editOrder';
import lang from './../languages/en';
import history from './../services/history';
import { alertSuccess } from './../services/dialog';

export function* editOrderSaga() {
    yield takeLatest(EDIT_ORDER, editOrderHandle)
}

// get order by id
function* editOrderHandle(action) {
    try {
        const response = yield call(editOrder, action.payload)
        if (response.data.code !== 10001) {
            yield put({ type: EDIT_ORDER_FAILS, payload: response })
            handleException(response)
        }

        const channelOrderItem = yield call(channelOrderItemOfOrderFromAmazon, response.data.data.Order.ChannelOrderID)

        const postalCode = yield call(checkPostalCode, response.data.data.Order.ConsigneePostalCodeCH)
        if (response.data.code === 10001) {
            response['postalCode'] = postalCode.data.data
            response['channelOrderItem'] = channelOrderItem.data.data
            yield put({ type: EDIT_ORDER_SUCCESS, payload: response })
        }
    } catch (error) {
        yield put({ type: EDIT_ORDER_FAILS, payload: error })
        handleException(error)
    }
}

// update order
export function* updateOrderSaga() {
    yield takeLatest(UPDATE_ORDER, updateOrderHandle)
}

function* updateOrderHandle(action) {
    try {
        let data = action.payload
        if (typeof data.ConsigneeYomiganaName === 'string' && !data.ConsigneeYomiganaName.trim()) {
            const convertToYomigana = yield call(convertName, { OriginalString: data.ConsigneeName })
            if (convertToYomigana.data.data) {
                data.ConsigneeYomiganaName = convertToYomigana.data.data.ConvertedString
            }
        }

        const response = yield call(updateOrder, data)
        if (response.data.code === 10001) {
            yield put({ type: UPDATE_ORDER_SUCCESS, payload: response })
            history.push('/orders')
        } else {
            yield put({ type: UPDATE_ORDER_FAILS, payload: response })
            handleException(response)
        }
    } catch (error) {
        yield put({ type: UPDATE_ORDER_FAILS, payload: error })
        handleException(error)
    }
}

export function* restoreOrderSaga() {
    yield takeLatest(RESTORE_ORDER, restoreOrderHandle)
}

function* restoreOrderHandle(action) {
    try {
        const response = yield call(restoreOrderAmazon, action.payload)

        if (response.data.code === 10001) {
            response['restore'] = true

            yield put({ type: EDIT_ORDER_SUCCESS, payload: response })
            alertSuccess(lang.restore_order_success)
        } else {
            yield put({ type: EDIT_ORDER_FAILS, payload: response })
            handleException(response)
        }
    } catch (error) {
        yield put({ type: EDIT_ORDER_FAILS, payload: error })
        handleException(error)
    }
}


// WEBPACK FOOTER //
// ./src/sagas/editOrderSaga.js